// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  text-transform: capitalize;
}

.header {
  margin-bottom: 54px;
}
.header .plump {
  height: 51px;
  width: 54px;
  margin-right: 24px;
}

.lang-icon {
  margin-top: 20px;
  height: 30px;
  width: 30px;
}

.wrapper {
  color: var(--color-black);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .center-section {
  padding: 30px 15px 15px 20px;
}
.wrapper .header-section {
  padding: 38px 30px;
  height: 100%;
}

.separator {
  width: 100%;
  margin: 16px 0;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
  color: var(--color-black);
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin-bottom: 5px;
  font-family: Title;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}

.email {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 121%;
  letter-spacing: 2%;
  vertical-align: middle;
}

a {
  text-decoration: none;
  color: black;
}

ion-button {
  width: 100%;
  min-height: 54px;
  font-size: 17px;
  --background: #2D69AA;
}

.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

ion-col {
  font-size: 20px;
  color: var(--color-black);
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
}

.header-wrap-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-black);
}

.selected {
  opacity: 1 !important;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
  color: var(--color-black);
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0px 5px;
  text-align: center;
  width: 48%;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: transparent;
  border-radius: 50px;
  overflow: hidden;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-lang div span {
  text-transform: uppercase;
  font-size: 14px !important;
  color: var(--ion-color-primary);
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  border: none;
}
.footer-lang div.selected span {
  color: white;
}

.footer-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.footer-block .lang-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.footer-block .lang-block .lang-item {
  padding: 5px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  margin-right: 10px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  border: 1px solid var(--color-black);
  background: white;
}
.footer-block .lang-block .lang-item ion-icon {
  width: 18px;
  height: 18px;
  padding: 0px;
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
}
.footer-block .lang-block .lang-item h3 {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  transition: color 0.3s ease;
}
.footer-block .lang-block .lang-item.selected {
  background: var(--ion-color-primary);
}
.footer-block .lang-block .lang-item.selected ion-icon {
  opacity: 1;
}
.footer-block .lang-block .lang-item.selected h3 {
  color: white;
}
.footer-block .logout {
  zoom: 1.5;
  margin: 0px;
}

.footer-section-desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);
}
.footer-section-desktop .left-section p {
  font-size: 12px;
  font-family: AppFontMedium;
  padding-bottom: 10px;
  cursor: pointer;
}
.footer-section-desktop .left-section p:hover {
  color: var(--ion-color-primary);
}
.footer-section-desktop .right-section .lang-block {
  display: flex;
  align-items: center;
}
.footer-section-desktop .right-section .lang-block .vertical-line {
  margin: 0px 20px;
  width: 1px;
  height: 20px;
  background: var(--color-black);
}
.footer-section-desktop .right-section .lang-block h3 {
  font-size: 16px;
  font-family: AppFontMedium;
  cursor: pointer;
}
.footer-section-desktop .right-section .lang-block .lang-item.selected h3 {
  font-family: AppFontBold;
}

@media (min-width: 991px) {
  .block-items {
    height: 200px;
  }
}

.logout-block {
  width: -moz-fit-content;
  width: fit-content;
  padding: 10px;
  border: 1px solid var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
  margin-left: 20px;
  min-width: 150px;
  text-align: center;
}

ion-row:hover ion-col {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,kBAAA;EACA,0BAAA;AAAD;;AAEA;EACC,mBAAA;AACD;AAAC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAEF;;AAEA;EACC,gBAAA;EACA,YAAA;EACA,WAAA;AACD;;AACA;EACC,yBAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACD;AAAC;EACC,4BAAA;AAEF;AAAC;EACC,kBAAA;EACG,YAAA;AAEL;;AAEA;EACC,WAAA;EACA,cAAA;AACD;;AAEA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AACD;;AAEA;EACC,YAAA;EACA,kBAAA;EACA,yBAAA;AACD;;AAEA;EACC,mBAAA;EACA,YAAA;EACA,eAAA;AACD;;AAEA;EACC,kBAAA;EAEA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,qBAAA;EACA,YAAA;AAAD;;AAGA;EACC,WAAA;EACA,gBAAA;EACG,eAAA;EACH,qBAAA;AAAD;;AAEA;EACC,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACD;;AACA;EACC,eAAA;EACA,yBAAA;AAED;;AACA;EACC,qBAAA;AAED;;AAAA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAGD;;AADA;EACC,SAAA;AAID;;AADA;EACC,eAAA;AAID;;AAFA;EACC,YAAA;AAKD;;AAFA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;AAKD;;AAHA;EACC,qBAAA;AAMD;;AAHA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AAMD;;AAHA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAMD;AAJC;EACC,iBAAA;AAMF;AAJC;EACC,eAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,0CAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAMF;AALE;EACC,yBAAA;EACA,0BAAA;EACA,+BAAA;AAOH;AAHE;EAIC,oCAAA;EACA,YAAA;AAEH;AANG;EACC,YAAA;AAQJ;;AADA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAID;AAHC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;AAKF;AAJE;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,oCAAA;EAQA,iBAAA;AADH;AANG;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;AAQJ;AALG;EACC,gCAAA;EACA,eAAA;EACA,yBAAA;EAEA,2BAAA;AAMJ;AAHG;EACC,oCAAA;AAKJ;AAJI;EACC,UAAA;AAML;AAJI;EACC,YAAA;AAML;AADC;EACC,SAAA;EACA,WAAA;AAGF;;AAAA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,wDAAA;AAGD;AAAE;EACC,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,eAAA;AAEH;AAAE;EACC,+BAAA;AAEH;AAEE;EACC,aAAA;EACA,mBAAA;AAAH;AACG;EACC,gBAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;AACJ;AACG;EACC,eAAA;EACA,0BAAA;EACA,eAAA;AACJ;AAGK;EACC,wBAAA;AADN;;ACvQE;ED+QF;IAEE,aAAA;EALA;AACF;;AAOA;EACC,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAJD;;AAQE;EACC,+BAAA;AALH","sourcesContent":["@import '../../../theme/mixins';\napp-menu-modal {\n\tposition: relative;\n\ttext-transform: capitalize;\n}\n.header {\n\tmargin-bottom: 54px;\n\t.plump {\n\t\theight: 51px;\n\t\twidth: 54px;\n\t\tmargin-right: 24px;\n\t}\n}\n\n.lang-icon {\n\tmargin-top: 20px;\n\theight: 30px;\n\twidth: 30px;\n}\n.wrapper {\n\tcolor: var(--color-black);\n\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\t.center-section {\n\t\tpadding: 30px 15px 15px 20px;\n\t}\n\t.header-section {\n\t\tpadding: 38px 30px;\n    \theight: 100%;\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tmargin: 16px 0;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n\tcolor: var(--color-black);\n}\n\nion-row {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\n.name {\n\tmargin-bottom: 5px;\n\n\tfont-family: Title;\n\tfont-size: 28px;\n\tline-height: 100%;\n\tletter-spacing: 0%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n}\n\n.email {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 121%;\n\tletter-spacing: 2%;\n\tvertical-align: middle;\n}\n\na {\n\ttext-decoration: none;\n\tcolor: black;\n}\n\nion-button {\n\twidth: 100%;\n\tmin-height: 54px;\n    font-size: 17px;\n\t--background: #2D69AA;\n}\n.lang-row {\n\tfont-size: 20px;\n\tfont-family: AppFont, sans-serif;\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: nowrap;\n}\nion-col {\n\tfont-size: 20px;\n\tcolor: var(--color-black);\n}\n\n.selected {\n\topacity: 1 !important;\n}\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\nion-icon {\n\tzoom: 1.1;\n}\n\nion-row {\n\tmargin-top: 6px;\n}\n.header-wrap {\n\tmargin: 10px;\n}\n\n.header-wrap-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder-bottom: 1px solid var(--color-black);\n}\n.selected {\n\topacity: 1 !important;\n}\n\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n\tcolor: var(--color-black);\n}\n\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\n\tdiv:first-child {\n\t\tmargin-left: 20px;\n\t}\n\tdiv {\n\t\tmargin: 0px 5px;\n\t\ttext-align: center;\n\t\twidth: 48%;\n\t\t--border-color: var(--ion-color-primary);\n\t\tborder: 2px solid var(--ion-color-primary);\n\t\tbackground: transparent;\n\t\tborder-radius: 50px;\n\t\toverflow: hidden;\n\t\tpadding: 12px 30px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-weight: bold;\n\t\tspan {\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 14px !important;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tspan {\n\t\t\t\tcolor: white;\n\t\t\t}\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tborder: none;\n\t\t}\n\t}\n}\n.footer-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 30px;\n\t.lang-block {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\t.lang-item {\n\t\t\tpadding: 5px 25px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: 26px;\n\t\t\tmargin-right: 10px;\n\t\t\ttransition: background-color 0.3s ease;\n\t\t\tcursor: pointer;\n\t\t\tborder: 1px solid var(--color-black);\n\t\t\tion-icon {\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t\tpadding: 0px;\n\t\t\t\topacity: 0.5;\n\t\t\t\ttransition: opacity 0.3s ease-in-out;\n\t\t\t}\n\t\t\tbackground: white;\n\t\t\th3 {\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: var(--color-black);\n\n\t\t\t\ttransition: color 0.3s ease;\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tion-icon {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\th3 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.logout {\n\t\tzoom: 1.5;\n\t\tmargin: 0px;\n\t}\n}\n.footer-section-desktop {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 20px;\n\tbox-shadow: 3px 0px 45px 0px #00000012;\n\t// border-top: 1px solid #DCE8F5;\n\t.left-section {\n\t\tp {\n\t\t\tfont-size: 12px;\n\t\t\tfont-family: AppFontMedium;\n\t\t\tpadding-bottom: 10px;\n\t\t\tcursor: pointer;\n\t\t}\n\t\tp:hover {\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n\t.right-section {\n\t\t.lang-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.vertical-line {\n\t\t\t\tmargin: 0px 20px;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: 20px;\n\t\t\t\tbackground: var(--color-black);\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t\t.lang-item {\n\t\t\t\t&.selected {\n\t\t\t\t\th3 {\n\t\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.block-items {\n\t@include desktop {\n\t\theight: 200px;\n\t}\n}\n.logout-block {\n\twidth: fit-content;\n\tpadding: 10px;\n\tborder: 1px solid var(--color-black);\n\tborder-radius: 26px;\n\ttext-transform: uppercase;\n\tfont-size: 14px;\n\tcursor: pointer;\n\tmargin-top: 20px;\n\tmargin-left: 20px;\n\tmin-width: 150px;\n\ttext-align: center;\n}\nion-row {\n\t&:hover {\n\t\tion-col {\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
